 
export const AcceptanceRouting = [
  {
    path: "/finished-project/acceptance/list",
    name: "acceptance-list",
    meta: { title: "竣工验收" },
    component: () => import("@/views/finished-project/acceptance/list/index.vue"),
  },
  {
    hidden: true,
    path: "/finished-project/acceptance/create",
    name: "acceptance-create",
    meta: { title: "新建竣工验收",comName:"finishedProjectAcceptanceFormCreate"  },
    component: () => import("@/views/finished-project/acceptance/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/finished-project/acceptance/edit/:id",
    name: "acceptance-edit",
    meta: { title: "编辑竣工验收",comName:"finishedProjectAcceptanceFormCreate"  },
    component: () => import("@/views/finished-project/acceptance/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/finished-project/acceptance/detail/:id",
    name: "acceptance-detail",
    meta: { title: "竣工验收详情" },
    component: () => import("@/views/finished-project/acceptance/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/finished-project/acceptance/flowPrint/:id",
    name: "finished-project-acceptance-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "finished-project-acceptance" */ "@/views/finished-project/acceptance/flow-print/index.vue"
      ),
  }
];
